module.exports = __webpack_public_path__ + "images/emoji/sparkling_heart.e972b131ea93d2c02e1f.png";